import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const TicketIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      {...props}
    >
      <path
        d="M12.4338 4.5625H18.4375C19.2659 4.5625 19.9375 5.23407 19.9375 6.0625V12.0662C19.9375 12.464 19.7795 12.8455 19.4982 13.1268L12.2482 20.3768C11.6624 20.9626 10.7126 20.9626 10.1268 20.3768L4.12316 14.3732C3.53737 13.7874 3.53737 12.8376 4.12316 12.2518L11.3732 5.00184C11.6545 4.72054 12.036 4.5625 12.4338 4.5625Z"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <circle
        cx="1.25"
        cy="1.25"
        r="1.25"
        transform="matrix(-1 0 0 1 16.5 8)"
        fill={strokeColor}
      />
    </svg>
  );
};
